const Data = [
    {
        id:1,
        img:"/assets/blog02.png",
        text:"GPT-3 and Open Ai is the Future let's Explore how it is ",
        date:"12th Jan 2022"
    },
    {
        id:2,
        img:"/assets/blog03.png",
        text:"GPT-3 and Open Ai is the Future let's Explore how it is ",
        date:"23th Feb 2022"
    },
    {
        id:3,
        img:"/assets/blog04.png",
        text:"GPT-3 and Open Ai is the Future let's Explore how it is ",
        date:"11th Jan 2022"
    },
    {
        id:4,
        img:"/assets/blog05.png",
        text:"GPT-3 and Open Ai is the Future let's Explore how it is ",
        date:"12th June 2022"
    }
]
export default Data;